// hsIdentityReset.js (or put near your logout logic)
// NOTE: works even if HubSpot scripts were never loaded.

export function hsResetIdentity() {
  // 1) Queue analytics reset for when HubSpot loads later
  window._hsq = window._hsq || [];
  window._hsq.push(['reset']); // clears hubspotutk session on next load

  // 2) Proactively clear key cookies used by chat and tracking
  const cookies = ['hubspotutk', 'messagesUtk', '__hstc', '__hssc', '__hssrc'];
  const base = window.location.hostname.replace(/^www\./, '');
  cookies.forEach((name) => {
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    document.cookie = `${name}=; domain=${base}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  });

  // 3) Clear likely storage keys (safe to ignore if absent)
  const zap = (k) => /^hs-|^hubspot|messages|^__hs/i.test(k);
  try {
    Object.keys(localStorage).forEach((k) => zap(k) && localStorage.removeItem(k));
    Object.keys(sessionStorage).forEach((k) => zap(k) && sessionStorage.removeItem(k));
  } catch {}

  // 4) Mark a "deferred reset" so the chat widget refreshes on first load
  window.__hsDeferredReset = Date.now();

  // 5) Best effort: if widget already exists, refresh/remove now
  try {
    window.HubSpotConversations?.widget?.remove?.(); // fully removes if present
    // or: window.HubSpotConversations?.widget?.refresh?.();
  } catch {}
}
